import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList } from '../../../../../utils/appNavigationNames';
import ProfileConnectContent from '../../../../shared/ProfileConnectContent';

export type ConnectScreenOwnProps = {};

export type ConnectScreenProps = ConnectScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'connect'>;
};

const ConnectScreenScreen: React.FC<ConnectScreenProps> = (props) => {
    return (
        <ProfileConnectContent
            medicalProfileId={props.route.params.profileId}
            forceRefresh={props.route.params.forcePortalRefresh === 'true'}
            forceFastenRefresh={props.route.params.forceFastenRefresh === 'true'}
            showFastenPendingAlert={props.route.params.showFastenPendingAlert === 'true'}
        />
    );
};

export default React.memo(ConnectScreenScreen);
